const mobileRegex = /^\+?\d{8,18}$/;

export const isValidMobileNumber = (number: string) => {
  return mobileRegex.test(number);
};
